import Partners from "./partners";
import Certifications from "./certifications";
import Process from "./process";
import Reporting from "./reporting";

export default [...Partners, ...Process, ...Certifications, ...Reporting];
